import Reviews from "components/homepage/reviews";
import ServicesGrid from "components/homepage/servicesGrid";
import TranslateAgency from "components/homepage/translateAgency";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocationBanner from "components/locationBanner";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import React from "react";
import AcadmicInstruction from "../AcadmicInstruction";
import Benifits from "../Benifits";
import Certify from "../certify";
import LocalizationMidText from "../localizationMidText";
import TechnicalDocument from "../technicalDocument";
import TranslationServiceCards from "../translationServiceCards";
import { FinancialCardData, LegalTransData } from "./config";
import EveryNeed from "./Everyneed";
import NewCertifyLegal from "./NewCertifyLegal";

function LegalTranslation() {
  return (
    <>
      <LocationBanner
        backgroundCol="bg-midBlue"
        title="Legal Translation Services"
        content="Tomedes provides legal translation services for legal firms and legal institutions. Legal translators understand the nuances and subtleties of specific terms to ensure that the legal translations they deliver are 100% accurate and certifiable. At Tomedes, our legal translation services are done by legal translators versed in over 120 languages and 950+ language pairs, with a 1-year guarantee, rapid delivery, and 24/7 customer support."
        formOrangeHead="Get in touch "
        formWhiteHead="with our legal translation company"
      />
      {/* <AcadmicInstruction
        BackgroundCol="bg-darkBlue"
        colorHead="Trusted"
        head="Legal Translation Services "
        secondHead="by Legal Institutions Worldwide"
        content="Our legal translation services are trusted by small, medium, and large legal institutions worldwide. Join our satisfied customers in the legal field today."
      /> */}
      <TranslateAgency
        head="Legal Translation Services"
        colorHead="by Legal Institutions Worldwide"
        content="Our legal translation services are trusted by small, medium, and large legal institutions worldwide. Join our satisfied customers in the legal field today."
      />
      <LocalizationMidText
        backgroundCol="bg-midBlue"
        orangeMidText="Legal"
        content="Translation Services help brands and organizations achieve their global objectives. We provide scalable and guaranteed solutions that are delivered on-time by our team of experts."
      />
      <SpeceficTranslation
        getStarted
        backgroundCol="bg-darkBlue"
        FirstWhite=" "
        ColorHead="Translate Your Legal Documents in Over 120 Languages and 950+ Language Pairs"
        SecondWhitePcer="Your Legal Documents in Over 120 Languages and 950+ Language Pairs"
        headColor="text-#e6e6e6"
        Content="Our legal translation services are done by experienced professionals in the legal field. We've successfully completed legal projects in over 120 languages and 950+ language pairs. We also transcribe and translate testimony and depositions as well as provide certified interpretation services."
        linkName=" "
      />
      {/* <Certify
        src="https://skins.tomedes.com/frontend/images/services-new/legal_translation.svg"
        head=" "
        backgroundCol="bg-midBlue"
        colHead="WHAT"
        secondHead="IS LEGAL TRANSLATION?"
        para="Legal translation is one of the most sensitive fields in translation, a mistranslation can lead to malpractice lawsuits or in more extreme cases, it can cost someone's freedom. We deal with legal translations with the utmost care and consideration."
        leftHeadingFirst="Legal Translation -"
        leftHeadingmid="Defined"
        leftHeadingSecond=" "
        leftHeadingPara="Legal translation is the field of translation that transforms legal materials from one language to another. Since law is dependent on culture, it takes more than translations but also a knowledge of two or more countries' legal systems for legal translations to work."
        bottomleftHeadingFirst="How Do We"
        bottomleftHeadingmid="Hire"
        bottomleftHeadingSecond="Your Legal Translator?"
        bottomleftHeadingPara="Learn more about our translator selection process."
        RightHeadingFirst="
         The legal translation"
        RightHeadingmid="process"
        RightHeadingSecond=" "
        RightHeadingPara="Our legal translation agency facilitates a 2-step hiring process to hire translators. We use a combination of human reviewers and QA platforms to assess the linguistic and law expertise of each translator applicant. Then their work is audited via our internal review system using the factors of client feedback, professionalism, and consistency. When it comes to legal translators, we take into account their knowledge of two or more countries' laws and regulations."
        ListFirst="Project management"
        ListSecond="Legal analysis"
        ListThird="Translation"
        ListFourth="LQA"
      /> */}
      <NewCertifyLegal />

      <Benifits
        BackgroundCol="bg-darkBlue"
        firsttitle=" "
        secondTitle="Features"
        thirdTitle=" "
        BefitisData={LegalTransData}
      />
      <TechnicalDocument
        backgroundCol="bg-midBlue"
        firstHead=" "
        headColor="text-orange"
        colHead="Looking"
        secondHead="for a Legal Translator?"
        para="Tomedes assigns specialized legal translation teams to translate and certify legal documents of all kinds to meet
        the exacting requirements of officers of the court and the standards of authorities in every jurisdiction.
        Contact us for a legal translator today, we reply in 30 minutes."
      />
      <ServicesGrid
        heading="Legal Translation for Every Industry"
        backgroundCol="bg-darkBlue"
        colorComp=" "
        details="Tomedes' translators are versed in corporate law, family law, environmental law, entertainment law, bankruptcy law, civil rights law, maritime law, and much more. That diversity of our coverage ensures that the translations that we execute for you come across as both knowledgeable and natural to the clients and courts you serve, whichever industry you're in."
      />
      <EveryNeed backgroundCol="bg-midBlue" />
      <TranslationServiceCards
        colheading="Case Studies"
        topHead=" "
        borderB=" "
        topHead2="of our Recent Legal Translations"
        cardData={FinancialCardData}
        backgroundCol="bg-darkBlue"
        content
      />
      <WhatChooseUs backgroundCol="bg-midBlue" />
      <Reviews backgroundCol="bg-darkBlue" />
      <TranslationServices backgroundCol="bg-midBlue" />
    </>
  );
}

export default LegalTranslation;
